import { t } from 'i18next';
import PhotoCardPost from '../../components/card/PhotoCardPost';
import { useSelectedTradingCardsStore } from '../store/useSelectedTradingCardsStore';
import type { TradingPhotoCardType } from '../types/TradingPhotoCardType';
import { getPhotoCardBadges } from '../../utils/getPhotoCardBadges';

interface RegisterSalePhotoCardProps {
  card: TradingPhotoCardType;
}

const RegisterSalePhotoCard = ({ card }: RegisterSalePhotoCardProps) => {
  const { selectedPhotoCards, setSelectedPhotoCards, removePhotoCard } =
    useSelectedTradingCardsStore();
  const handleInputChange = (value: string | undefined) => {
    setSelectedPhotoCards(
      selectedPhotoCards.map((c) =>
        c.tradingPhotoCardId === card.tradingPhotoCardId ? { ...c, price: value || '' } : c
      )
    );
  };

  const handleDelete = () => {
    removePhotoCard(card.tradingPhotoCardId);
  };

  const title = t('NewTradingPhotoCards.photoCardTitle', {
    artist: card.photoCard.memberName,
    category: card.photoCard.categoryName,
    categoryEmoji: card.photoCard.categoryEmoji
  });
  const badges = getPhotoCardBadges(card.photoCard);
  return (
    <div key={card.tradingPhotoCardId} className="flex flex-col py-[8px]">
      <PhotoCardPost
        title={title}
        subtitle={card.photoCard.eventName}
        imageUrl={card.photoCard.pictureUrl}
        showClose={true}
        onClose={handleDelete}
        onInputChange={handleInputChange}
        showInput={true}
        badges={badges}
        inputValue={card.price ?? ''}
      />
    </div>
  );
};

export default RegisterSalePhotoCard;
